<template>
  <div class='EnbPagamentos'>
    <enb-mp/>
    <enb-wa/>
  </div>
</template>

<script>
import EnbMp from './EnbMp/EnbMp'
import EnbWa from './EnbWa/EnbWa'
export default {
  name: 'EnbPagamentos',
  components: { EnbMp, EnbWa }
}
</script>

<style scoped>
.EnbPagamentos {
  width: 96%;
  height: 96%;
  padding: 2%;
  padding-top: 0%;
}
</style>
